import { useRef } from "react";
import { useAtom } from "jotai";

import { MobileTopNav } from "@/components/molecules/MobileTopNav";
import { MobileBottomNav } from "@/components/molecules/MobileBottomNav";
import { BrowsePage } from "@/components/pages/BrowsePage";
import { isModalOpenAtom, isInitialPageLoadingAtom } from "@/constants/atoms";
import { useClassNames } from "@/utils/classNames";
import { LoadingWorm } from "@/components/atoms/LoadingWorm";

import styles from "./Mobile.module.scss";

function Mobile() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const [isModalOpen] = useAtom(isModalOpenAtom);
  const [isInitialPageLoading] = useAtom(isInitialPageLoadingAtom);

  const cn = useClassNames(
    styles,
    styles["mobile"],
    isModalOpen && styles["modal-open"],
  );

  return (
    <>
      <LoadingWorm open={isInitialPageLoading} />

      <div
        className={cn}
        ref={scrollContainerRef}
        style={{
          opacity: isInitialPageLoading ? 0 : 1,
          pointerEvents: isInitialPageLoading ? "none" : "auto",
          visibility: isInitialPageLoading ? "hidden" : "visible",
        }}
      >
        {!isInitialPageLoading && (
          <MobileTopNav scrollContainerRef={scrollContainerRef} />
        )}

        <BrowsePage
          slug="/home"
          fetchTileDetails={true}
          skipPersonalized={true}
          showMobileContent={true}
          enableLazyLoading={true}
          batchSize={5}
          initialBatchSize={5}
          loadThreshold={800}
          scrollContainerRef={scrollContainerRef}
          railItemLimits={{
            "Live & Upcoming": 12,
            "Can't Miss Highlights": 12,
          }}
        />

        {!isInitialPageLoading && <MobileBottomNav />}
      </div>
    </>
  );
}

export { Mobile };
